import React from 'react'
import { FC } from 'react'
import numeral from 'numeral'

export interface AffiliationListItemProps {
    imagePath: string
    label: string
    percentage: number
    affiliationName: string
    imageAlternateText: string
}
export const AffiliationListItem: FC<AffiliationListItemProps> = props =>
(
    <div className="affiliation-grid-item">
        <div className="affiliation-grid-item-container">
            {props.imagePath && <img className={props.label ? 'grid-image-item-of-three' : 'grid-image-item-of-two'} src={`${imod.cms.scoreboards.baseUrl}/${props.imagePath}`} alt={props.imageAlternateText} tabIndex={0} />}
            {props.label && <span className={`${props.imagePath ? 'grid-text-item-of-three' : 'grid-text-item-of-two'} grid-item-label`}>{props.label}</span>}
            <span className={`${props.imagePath ? 'grid-text-item-of-three' : 'grid-text-item-of-two'} grid-item-percentage`}>{numeral(props.percentage).format('0%')}</span>
        </div>
    </div >
)

AffiliationListItem.displayName = 'AffiliationListItem'
